/**
 * CAMERA + HÌNH HỌC THUẦN CỦA ARENA (sân 2 CHIỀU TỰ DO: SÔNG + 2 CẦU, KHÔNG CÒN 3 LAND).
 *
 * ════════════════════════════════════════════════════════════════════════════════════════════
 * VÌ SAO PHẢI CÓ CLASS NÀY — ĐÂY LÀ CHẶN KỸ THUẬT LỚN NHẤT CỦA T-C
 * ════════════════════════════════════════════════════════════════════════════════════════════
 * Sân TD hiện tại (`ArenaScene.create`) cố định `setViewport(0, 0, ARENA.w, ARENA.h)` = 1000×600
 * với THẾ GIỚI cũng đúng 1000×600 ⇒ camera chưa bao giờ phải cuộn, và mọi toạ độ world trùng khít
 * toạ độ màn hình. Arena là màn NGANG 2400×1000 (3 land × 2 phe) ⇒ **buộc phải cuộn**, và đó là
 * lần đầu repo có khái niệm "world ≠ viewport".
 *
 * ⚠️⚠️ BẪY #1 — CAMERA PHẢI GIỮ CỠ THIẾT KẾ, KHÔNG THEO `scale.width` (BẪY ĐÃ SẬP TRONG REPO).
 * Chú thích trong `ArenaScene.create` ghi lại nguyên văn: từng đặt camera bằng
 * `scale.width/height` (1576×404, cỡ khung chứa) trong khi thế giới chỉ 1000×600 ⇒
 * `getWorldPoint()` trả toạ độ SAI và mọi cú bấm lệch hẳn — đo được: bấm giữa sân ra `orderX 787`
 * thay vì ~500. Với camera cuộn thì bẫy này còn NẶNG HƠN: sai `viewW` ⇒ sai luôn `scrollX`, và
 * `getWorldPoint()` cộng thêm một lượng lệch nữa, tức SAI HAI LẦN.
 * ⇒ `ArenaCamera` KHÔNG BAO GIỜ tự đọc `scale.width`; cỡ nhìn phải được TRUYỀN VÀO (`resize`).
 *
 * ⚠️ BẪY #2 — KHÔNG ĐƯỢC CÓ KHOẢNG TRỐNG NGOÀI MAP. Nếu `scrollX` vượt biên thì mép trái/ phải
 * màn hình lộ ra vùng đen (không có texture nào ở đó) ⇒ người chơi tưởng game lỗi. Mọi phép tính
 * dưới đây đi qua `clampScroll` nên bất biến "viewport luôn nằm TRONG thế giới" được khoá bằng test.
 *
 * ⚠️ BẪY #3 — 2400 CHIA 1000 KHÔNG HẾT. Khi `viewW` không phải ước của `worldW`, điểm cuối của
 * dải cuộn KHÔNG rơi đúng toạ độ Nhà địch (2400 − 1000 = 1400, mà Nhà phải ở `x = 2250`). Nếu vẽ
 * Nhà ĐỊCH bằng graphics NẰM TRONG THẾ GIỚI rồi để camera kẹp biên, Nhà đó sẽ bị CẮT CỤT ở mép
 * phải màn hình ⇒ "phá Nhà địch" — điều kiện thắng của cả trận — không còn đọc được bằng mắt.
 * (Đây là lựa chọn CÓ ĐO: xem khối chú thích lớn trong `arena-battle.ts` về cách vẽ 2 Nhà.)
 *
 * ════════════════════════════════════════════════════════════════════════════════════════════
 * ⚠️⚠️ VÌ SAO FILE NÀY **0 IMPORT** — KHÔNG PHẢI TÌNH CỜ, ĐỪNG "CHO GỌN" BẰNG CÁCH THÊM IMPORT
 * ════════════════════════════════════════════════════════════════════════════════════════════
 * File này là **vùng Phaser-free** của toàn bộ tầng hiển thị Arena: 0 `import`, nên nó chạy được
 * trong môi trường node của vitest. Ban đầu tôi để các hàm hình học/ dữ liệu thuần ở
 * `arena-battle.ts` (nơi chúng "thuộc về" về mặt khái niệm) — và `tests/arena-render.test.ts` ĐỎ
 * ngay bằng lỗi `ReferenceError: window is not defined`, vì `arena-battle.ts` có
 * `import Phaser from 'phaser'` ở đầu file và Phaser cần DOM/ WebGL.
 *
 * Đó là bài học đáng ghi lại: trong repo này, **test chỉ import được những module KHÔNG kéo Phaser**
 * (xem `tests/arena.test.ts`/ `tests/fx.test.ts`/ `tests/projectiles.test.ts` — tất cả chỉ import
 * `src/sim/` và `src/data/`). Vì vậy mọi thứ cần test được phải nằm ở một module riêng không import
 * Phaser; `arena-battle.ts` re-export lại để nơi dùng chỉ cần một đường import.
 *
 * ⚠️ HỆ QUẢ: **TUYỆT ĐỐI không thêm `import Phaser`** vào file này — kể cả `import type`, để không mở
 * đường cho người sau đổi nó thành import THẬT và làm đỏ test theo đúng cách khó hiểu nhất (lỗi
 * `window is not defined`, không phải lỗi biên dịch).
 *
 * ⚠️ NGOẠI LỆ DUY NHẤT ĐƯỢC PHÉP: 2 `import type` ở dưới (`ArenaUnit`/ `ArenaWorld` của
 * `sim/arena/types`). Chúng bị XOÁ HOÀN TOÀN lúc biên dịch nên không kéo gì vào lúc chạy — và
 * `sim/arena/types.ts` cũng 0-import Phaser (đó là luật kiến trúc của chính nó). Đã kiểm: bộ test
 * import file này chạy được trong node, tức tính chất 0-import runtime vẫn nguyên.
 * Ai muốn thêm import thứ ba thì phải chứng minh được điều tương tự — mặc định là KHÔNG.
 */

/*
 * ⚠️ DUY NHẤT HAI `import type` — CHÚNG BỊ XOÁ HOÀN TOÀN LÚC BIÊN DỊCH ("type-only import"), nên
 * KHÔNG kéo `sim/arena` (và càng không kéo Phaser) vào lúc chạy. Nhờ vậy file này vẫn 0-import THẬT
 * và test được trong môi trường node — xem khối chú thích đầu file.
 * TUYỆT ĐỐI không đổi 2 dòng này thành `import` thường: làm vậy là tự phá tính chất 0-import.
 */
import type { ArenaUnit } from '../sim/arena/types';

/** Một phe. Khai lại ĐÚNG 2 giá trị của `ArenaSide` — xem chú thích `ArenaCamGeometry.view`. */
export type CamSide = 'left' | 'right';

/**
 * CẤU TRÚC TỐI THIỂU mà `UnitViews.sync` thật sự đọc.
 *
 * ⚠️ Vì sao KHÔNG phải `World` của game TD cũ (kiểu mà `unitview.ts` đang khai): `UnitViews.sync()`
 * chỉ đọc ĐÚNG 2 trường `world.units` và `world.time` (đã `grep` kiểm chứng), còn `World` mang thêm
 * ~20 trường Arena cố ý không có (`gold`, `projectiles`, `hitStop`…). Nhận cấu trúc tối thiểu thì
 * `ArenaWorld` khớp TỰ NHIÊN (structural typing), không cần ép kiểu, và TypeScript còn bắt được lỗi
 * nếu ai đó truyền thiếu `time`.
 */
export interface ArenaWorldLike {
  units: ArenaUnit[];
  time: number;
}

/** Peer tối thiểu mà `UnitViews` cần — khai lại để KHÔNG import `unitview` (xem adapter ở mục 4b). */
export interface UnitViewsPeer {
  sync(dt: number, world: { units: ArenaUnit[]; time: number }): void;
  reset(): void;
}

/**
 * THẾ GIỚI ARENA — hằng số HIỂN THỊ, khai lại từ sim.
 *
 * ⚠️ Cố ý KHÔNG import từ `sim/arena/world.ts` để giữ file này 0-import — nhưng giá trị PHẢI khớp
 * sim, và `tests/arena-render.test.ts` đối chiếu với hằng số THẬT của sim nên lệch là đỏ ngay.
 * Đây là "bản sao có khoá": rẻ hơn một import kéo cả tầng sim (và cả Phaser gián tiếp qua chuỗi
 * import của nó) vào vùng test thuần.
 *
 * 🔢 CẬP NHẬT THEO LẦN CO MAP (1000×600 để thấy CẢ HAI Nhà — xem `ARENA_WORLD` trong sim):
 * trục X × `ARENA_XSCALE` (1000/2400), trục Y × 0,6. Đây là lý do bản sao này tồn tại như một chỗ
 * PHẢI SỬA mỗi khi đổi cỡ map — và test đối chiếu là lưới an toàn bắt đúng việc đó.
 */
export const ARENA_RENDER_WORLD = { w: 1000, h: 600 } as const;

/**
 * ⚠️ BỐN HẰNG SỐ/ HÀM "3 LAND" CỦA TẦNG VẼ ĐÃ BỊ XOÁ Ở REFACTOR "XOÁ 3 LAND" — GHI LẠI ĐỂ TRUY:
 *   · `ARENA_RENDER_LANE_Y` (`[120, 300, 480]`) — y của 3 dải land;
 *   · `ARENA_LAND_BAND` (62) — nửa bề dày vùng đi được của 1 dải;
 *   · `landBand(land)` — dải `{top, bottom}` của 1 land;
 *   · `ARENA_MINE_LANDS_RENDER` (`[0, 0, 2, 2]`) — thứ tự land của 4 mỏ.
 *
 * LUẬT ĐỔI, KHÔNG PHẢI "DỌN CHO GỌN": sân Arena nay là không gian 2 CHIỀU TỰ DO, chia bởi SÔNG dọc
 * + 2 CẦU (`src/sim/arena/river.ts`), không còn dải nào để vẽ/ để khoá unit. Giữ bản sao 3-land ở
 * tầng vẽ là giữ một nguồn sự thật trỏ vào khái niệm đã chết — và `tests/arena-render.test.ts` nay
 * khoá hình học SÔNG/ CẦU bằng hằng số THẬT của sim (`ARENA_RIVER`/ `ARENA_BRIDGES`).
 */

/** Sức chứa 1 chuyến của nông dân — khớp `ARENA_ECON.farmerCapacity` của sim. */
export const ARENA_FARMER_CAPACITY = 30;

/** Hình dạng tối thiểu của một unit để vẽ chỉ báo "đang vác đồ" — khai riêng cho test thuần. */
export interface CarryingUnit {
  /**
   * PHE theo ĐÚNG tên trường của `ArenaUnit.team` ('hero' | 'enemy').
   *
   * ⚠️ KHÔNG phải `CamSide` ('left' | 'right') — đây chính là chỗ hai khái niệm dễ bị lẫn và đã
   * làm typecheck đỏ trong lúc viết: `camSide` là "đang xem phe nào" (việc của camera), còn `team`
   * là "phe sở hữu unit" (dữ liệu của sim). Suy từ `team` ra `side` bằng `sideOfTeam()`.
   */
  team: 'hero' | 'enemy';
  x: number;
  y: number;
  radius: number;
  carrying: number;
  alive: boolean;
  isFarmer: boolean;
}

/**
 * CHỈ BÁO "ĐANG VÁC ĐỒ" — HÀM THUẦN, TEST ĐƯỢC KHÔNG CẦN PHASER.
 *
 * Yêu cầu người dùng (mục 6 của task): đọc `unit.carrying` và vẽ để MẮT đọc ra "con này đang vác
 * đồ về". Điều quan trọng nhất là chỉ báo phải xuất hiện ĐÚNG LÚC: hiện cả khi bao rỗng thì tín
 * hiệu mất hết ý nghĩa (mọi nông dân đều "đang vác"), mà đó lại là kiểu lỗi dễ mắc nhất.
 *
 * Trả `null` khi: unit chết, không phải nông dân, hoặc `carrying <= 0`.
 * `pct` = tỉ lệ đầy bao (`0..1`) — render dùng để phóng to túi + đổi màu khi sắp đầy.
 */
export function carryingIndicator(u: CarryingUnit): { pct: number; full: boolean } | null {
  if (!u.alive || !u.isFarmer) return null;
  if (!(u.carrying > 0)) return null;
  const pct = Math.max(0, Math.min(1, u.carrying / ARENA_FARMER_CAPACITY));
  return { pct, full: pct >= 1 };
}

/** Một mine đã sẵn sàng để vẽ: toạ độ + chỉ báo còn/ hết tài nguyên. */
export interface ArenaMineMarker {
  index: number;
  x: number;
  y: number;
  /** trữ lượng còn lại (đơn vị tài nguyên) */
  amount: number;
  /** `0..1` — tỉ lệ còn lại so với trữ lượng ban đầu của 1 mỏ */
  pct: number;
  /** `true` = CẠN: nông dân đứng chờ, người chơi phải thấy ngay (xem `drawMines`) */
  empty: boolean;
  /** `null` = mỏ trung lập (bản PVE cả 2 mỏ đều trung lập) */
  owner: CamSide | null;
}

/**
 * Dữ liệu mine tối thiểu mà tầng vẽ đọc từ sim — khớp `ArenaMine`.
 *
 * ⚠️ TRƯỜNG `land` ĐÃ BỊ XOÁ — LUẬT ĐỔI, KHÔNG PHẢI "DỌN CHO GỌN". Bản cũ khai `land: 0 | 1 | 2` để
 * tầng vẽ biết mỏ nằm ở dải nào; `ArenaMine` của sim đã bỏ `land` cùng "3 land" (xem
 * `sim/arena/types.ts`), và việc biết "mỏ ở góc nào" nay suy từ `y` (2 mỏ ở 2 GÓC map). Giữ trường
 * này là buộc nơi gọi phải BỊA ra một `land` chỉ để thoả kiểu — đúng loại "sửa cho qua typecheck".
 * Đây là ranh giới mà `tests/arena-render.test.ts` từng phải bắc CẦU NỐI TẠM; cầu nối đó nay đã xoá.
 */
export interface ArenaMineLike {
  index: number;
  x: number;
  y: number;
  amount: number;
  owner: CamSide | null;
}

/**
 * ĐỒNG BỘ 2 MINE TỪ SIM — hàm thuần, `maxAmount` truyền vào để KHÔNG phải import `ARENA_ECON`.
 *
 * ⚠️ KHÔNG TỰ ĐẶT TOẠ ĐỘ MINE Ở TẦNG VẼ — BẪY "NGUỒN SỰ THẬT THỨ HAI".
 * `src/data/arena.ts` ghi rõ toạ độ mine do `ArenaWorld` dựng trong constructor và task-7 đang chỉnh
 * cân bằng ngay trong đó; chép số ra tầng vẽ là tạo đúng cái lỗi "sửa một chỗ, chỗ kia giữ số cũ" mà
 * cả file `data/arena.ts` sinh ra để tránh. Vì vậy toạ độ LUÔN đọc từ `world.mines`.
 */
export function mineMarkers(mines: readonly ArenaMineLike[], maxAmount: number): ArenaMineMarker[] {
  return mines.map((m) => ({
    index: m.index,
    x: m.x,
    y: m.y,
    amount: m.amount,
    pct: Math.max(0, Math.min(1, m.amount / Math.max(1, maxAmount))),
    empty: m.amount <= 0,
    owner: m.owner,
  }));
}

/** Mine này có nằm trong vùng nhìn `[scrollLeft, scrollLeft + viewW)` không (bỏ qua mine vô hình). */
export function mineVisible(m: ArenaMineMarker, scrollLeft: number, viewW: number): boolean {
  return m.x >= scrollLeft - 40 && m.x <= scrollLeft + viewW + 40;
}

/** 🔢 Lề Nhà so với mép map — khớp `ARENA_CORE.leftX` của sim (150 × ARENA_XSCALE ≈ 62). */
export const ARENA_RENDER_CORE_MARGIN = 62;
export const ARENA_RENDER_MID_X = (ARENA_RENDER_CORE_MARGIN + (ARENA_RENDER_WORLD.w - ARENA_RENDER_CORE_MARGIN)) / 2;

/**
 * ẢNH NHÀ CÓ PHẢI LẬT THEO TRỤC X KHÔNG — HÀM THUẦN, MỘT NGUỒN SỰ THẬT CHO TẦNG VẼ.
 *
 * ⚠️ YÊU CẦU NGƯỜI DÙNG: *"Nhà bên phải phải flip lại cho đúng chiều"*.
 *
 * VÌ SAO CẦN: `art/ai/house.png` chỉ vẽ MỘT chiều — mặt tiền (cửa + đèn lồng) quay sang PHẢI, bức
 * tường hông thụt về bên trái. Vẽ nguyên chiều ấy cho cả hai Nhà thì Nhà PHẢI quay lưng vào sân: hai
 * Nhà "nhìn" cùng một hướng, đọc ra như hai sticker dán lên nền chứ không phải hai phe đối diện nhau
 * qua sông. Nhà TRÁI giữ nguyên (đã quay mặt vào trong, về phía sân), Nhà PHẢI lật gương (quay mặt
 * sang trái).
 *
 * ⚠️ VÌ SAO NẰM Ở MODULE THUẦN NÀY: `syncHouseArt` (trong `arena-battle.ts`) cầm `Phaser.GameObjects.
 * Image` nên KHÔNG test được trong môi trường node của vitest (xem khối chú thích ở
 * `ArenaCamGeometry`). Tách quyết định "phe nào lật" ra đây thì `tests/arena-render.test.ts` khoá
 * được nó bằng SỐ, đúng khuôn các quyết định hình học khác của tầng vẽ.
 */
export function houseArtFlipX(side: CamSide): boolean {
  return side === 'right';
}

/*
 * `ARENA_MINE_LANDS_RENDER` (`[0, 0, 2, 2]`) ĐÃ BỊ XOÁ CÙNG "3 LAND" — xem khối ghi chú ở mục
 * `ARENA_RENDER_WORLD` phía trên. Việc "mỏ ở góc nào" nay suy từ `y` của mỏ (2 góc trên/ dưới).
 */

/**
 * TOÀN BỘ TRẠNG THÁI CAMERA DƯỚI DẠNG DỮ LIỆU THUẦN.
 *
 * Vì sao tách khỏi class: `ArenaCamera` cầm một `Phaser.Camera` nên **không thể test trong môi
 * trường node** của vitest (Phaser cần DOM/ WebGL). Mọi phép tính hình học vì thế nằm ở các hàm
 * thuần dưới đây, và class chỉ còn là lớp mỏng "đọc trạng thái → gọi camera". Nhờ vậy
 * `tests/arena-render.test.ts` khoá được ĐÚNG những chỗ dễ sai nhất (kẹp biên, quy đổi toạ độ,
 * đổi cỡ cửa sổ) mà không cần một dòng Phaser nào.
 */
export interface ArenaCamGeometry {
  /** chiều rộng thế giới (px) — Arena = `ARENA_WORLD.w` = 2400 */
  worldW: number;
  /** chiều cao thế giới (px) — Arena = `ARENA_WORLD.h` = 1000 */
  worldH: number;
  /** chiều rộng vùng nhìn (cỡ THIẾT KẾ, xem bẫy #1). Luôn bị kẹp `<= worldW`. */
  viewW: number;
  /** chiều cao vùng nhìn. Trận này cuộn NGANG nên đây chỉ là số để suy `zoom` (xem `zoomFor`). */
  viewH: number;
  /** phe đang được xem — quyết định "người chơi nằm ở mép nào" */
  view: CamSide;
  /** mép trái vùng nhìn trong toạ độ thế giới. Bất biến: `0 <= scrollX <= worldW - viewW`. */
  scrollX: number;
  /** mép trên vùng nhìn. Bất biến: `0 <= scrollY <= worldH - viewH`. */
  scrollY: number;
}

// ════════════════════════════════════════════════════════════════════════════
// 1. KẸP BIÊN + CỠ NHÌN (nền của mọi thứ còn lại)
// ════════════════════════════════════════════════════════════════════════════

/**
 * Kẹp `v` vào `[0, max]`; `max < 0` (vùng nhìn to hơn thế giới) ⇒ về 0, KHÔNG trả số âm.
 *
 * ⚠️ XỬ LÝ `v` KHÔNG HỮU HẠN — ĐÃ SỬA MỘT LẦN, GHI LẠI VÌ RẤT DỄ "TỐI ƯU" NGƯỢC LẠI.
 * Bản đầu tôi viết `if (!Number.isFinite(v)) return 0;` cho gọn — SAI, và test bắt được:
 * `clampScroll(Infinity, 1400)` trả **0** (về tận mép trái) trong khi ý nghĩa của `Infinity` là
 * "cuộn xa hết mức" ⇒ phải trả `max`. Hệ quả nếu để nguyên: một phép chia hỏng ở đâu đó (delta
 * bằng 0, toạ độ `NaN`) sẽ làm camera NHẢY VỀ ĐẦU SÂN thay vì kẹp ở biên gần nhất — người chơi thấy
 * khung hình giật về 0 px một cách khó hiểu.
 *
 * Cách đúng: xử lý `NaN` riêng (không so sánh được ⇒ về 0), còn `±Infinity` để `Math.min`/`Math.max`
 * tự kẹp về đúng biên. `NaN` phải chặn TRƯỚC vì `Math.min(0, NaN)` = `NaN` ⇒ lan ra toàn bộ toạ độ.
 */
export function clampScroll(v: number, max: number): number {
  const hi = Math.max(0, max);
  if (Number.isNaN(v)) return 0;
  return Math.max(0, Math.min(hi, v));
}

/** Chiều rộng vùng nhìn hợp lệ: không vượt thế giới (vượt thì hết chỗ để cuộn, xem bẫy #2). */
export function viewWidthFor(worldW: number, viewW: number): number {
  return Math.max(1, Math.min(worldW, Math.round(viewW)));
}

/** Chiều cao vùng nhìn hợp lệ — cùng lý do như `viewWidthFor`. */
export function viewHeightFor(worldH: number, viewH: number): number {
  return Math.max(1, Math.min(worldH, Math.round(viewH)));
}

/** Điểm cuối của dải cuộn ngang. `0` khi vùng nhìn phủ trọn thế giới (hết chỗ cuộn). */
export function maxScrollX(worldW: number, viewW: number): number {
  return Math.max(0, worldW - viewWidthFor(worldW, viewW));
}

/** Điểm cuối của dải cuộn dọc. */
export function maxScrollY(worldH: number, viewH: number): number {
  return Math.max(0, worldH - viewHeightFor(worldH, viewH));
}

/**
 * ZOOM — CHỌN SAO CHO THẾ GIỚI **PHỦ KÍN** VÙNG NHÌN (điều kiện chống lộ khoảng trống).
 *
 * ⚠️⚠️ ĐỌC KỸ HAI VẾ, ĐÂY LÀ HÀM TỪNG SAI VÀ TEST BẮT ĐƯỢC.
 *
 * VẾ 1 — VÌ SAO CẦN ZOOM < 1 (lý do đã biết từ đầu): thế giới cao 1000px với `ARENA_LANE_Y` =
 * 200/500/800 ⇒ 3 land trải hết chiều cao. Vẽ 1:1 trên cửa sổ 700px thì land DƯỚI (y = 800) nằm
 * NGOÀI màn hình ở MỌI vị trí cuộn ⇒ người chơi không bao giờ thấy land của mình.
 *
 * VẾ 2 — VÌ SAO PHẢI XÉT CẢ CHIỀU NGANG (bản đầu tôi chỉ xét chiều dọc ⇒ SAI):
 * nếu `zoom` chỉ suy từ `viewH`, thì khi cửa sổ RỘNG (viewW = 2000, viewH = 700 ⇒ zoom = 0,7), bề
 * ngang vùng nhìn thấy được là `2000 / 0,7 = 2857` đơn vị world — **LỚN HƠN cả thế giới (2400)**.
 * Lúc đó thế giới KHÔNG THỂ phủ kín bề ngang màn hình, và mép phải lộ ra vùng trống dù `scrollX`
 * đã kẹp đúng biên. Đo được: `viewInsideWorld` trả `false` cho `viewW = 2000` — tức bất biến "không
 * lộ khoảng trống" đã vỡ.
 * Cách đúng: `zoom` phải là `max(viewW / worldW, viewH / worldH)` — tỉ lệ **cover**, lấy vế LỚN HƠN
 * để thế giới luôn phủ kín CẢ HAI chiều. Khi đó `viewW / zoom <= worldW` luôn đúng.
 *
 * ⚠️ TRẦN `<= 1`: KHÔNG bao giờ phóng to quá 1:1 (thế giới nhỏ hơn cửa sổ thì phóng to chỉ làm mờ
 * ảnh mà vẫn lộ khoảng trống hai bên). Trường hợp đó `maxScroll` = 0 và camera đứng yên — đúng.
 *
 * ⚠️ HỆ QUẢ BẮT BUỘC NHỚ: khi zoom ≠ 1 thì **1 đơn vị world = zoom px màn hình**. Mọi quy đổi toạ
 * độ (kể cả con trỏ chuột) phải chia cho `zoom`; xem `worldToScreenX`. Và `scrollX` KHÔNG còn là
 * "px màn hình" nữa (xem bẫy zoom ở `scrollXForFocus`).
 */
export function zoomFor(worldW: number, worldH: number, viewW: number, viewH: number): number {
  const cover = Math.max(viewWidthFor(worldW, viewW) / worldW, viewHeightFor(worldH, viewH) / worldH);
  // kẹp trong (0, 1]: sàn 0,05 chỉ để không bao giờ chia cho 0 nếu ai đó truyền worldH = 0
  return Math.max(0.05, Math.min(1, cover));
}

// ════════════════════════════════════════════════════════════════════════════
// 2. QUY ĐỔI WORLD ↔ MÀN HÌNH (có tính zoom — xem chú thích `zoomFor`)
// ════════════════════════════════════════════════════════════════════════════

/**
 * ZOOM CỦA MỘT GEOMETRY — gọi `zoomFor` với đủ 4 tham số.
 * Tồn tại để 8 chỗ dùng bên dưới không phải lặp lại `(g.worldW, g.worldH, g.viewW, g.viewH)`; nếu
 * lặp, chỉ cần một chỗ quên `viewW` là hình học lệch nhau giữa các hàm.
 */
export function zoomOf(g: ArenaCamGeometry): number {
  return zoomFor(g.worldW, g.worldH, g.viewW, g.viewH);
}

/**
 * Toạ độ world → px màn hình (đã tính zoom + đã trừ `scrollX`).
 * Đây là công thức mà `getWorldPoint()` của Phaser đảo ngược lại.
 */
export function worldToScreenX(g: ArenaCamGeometry, worldX: number): number {
  return (worldX - g.scrollX) * zoomOf(g);
}

/** Toạ độ world → px màn hình theo trục y (tương ứng `worldToScreenX`). */
export function worldToScreenY(g: ArenaCamGeometry, worldY: number): number {
  return (worldY - g.scrollY) * zoomOf(g);
}

/**
 * Lấy con trỏ chuột (px màn hình) ra toạ độ world.
 *
 * ⚠️⚠️ ĐÂY LÀ HÀM MÀ MỌI CÚ BẤM ĐI QUA — SAI Ở ĐÂY LÀ MỌI CÚ BẤM LỆCH (xem bẫy #1).
 * Vì sao phải viết ra thành hàm thuần để test thay vì tin `camera.getWorldPoint()`: lỗi cũ của
 * repo ("bấm giữa sân ra orderX 787") chỉ lộ ra khi chạy game thật — trong test đơn vị không có gì
 * bắt được. Viết công thức ra đây thì nó bị khoá bằng số ngay trong CI.
 */
export function screenToWorldX(g: ArenaCamGeometry, screenX: number): number {
  return g.scrollX + screenX / zoomOf(g);
}

/** Con trỏ chuột (px màn hình) → toạ độ world theo trục y. */
export function screenToWorldY(g: ArenaCamGeometry, screenY: number): number {
  return g.scrollY + screenY / zoomOf(g);
}

/** Số px MÀN HÌNH ứng với 1 đơn vị world — tên gọi rõ nghĩa cho `zoom`. */
export function screenPxPerWorldUnit(g: ArenaCamGeometry): number {
  return zoomOf(g);
}

// ════════════════════════════════════════════════════════════════════════════
// 3. ĐẶT NGƯỜI CHƠI Ở MÉP TRÁI (YÊU CẦU NGƯỜI DÙNG)
// ════════════════════════════════════════════════════════════════════════════

/**
 * VỊ TRÍ NGƯỜI CHƠI TRÊN MÀN HÌNH — tính bằng TỈ LỆ `[0..1]` bề ngang vùng nhìn.
 *
 * Người dùng chốt: *"người chơi LUÔN ở mép TRÁI màn hình khi PVE"*. 0,22 nghĩa là Nhà mình nằm
 * cách mép trái ~1/5 màn hình: đủ sát mép để đọc ra "ta ở bên trái", mà vẫn thấy được đất phía
 * sau lưng Nhà (camera kẹp ở scrollX = 0 nên phía sau Nhà chỉ có 150 − 0,22×viewW px).
 *
 * Vì sao KHÔNG đặt sát 0: Nhà rộng `ARENA_CORE.radius × 2 = 116px` + quầng sáng; dán vào mép là
 * mất nửa cái Nhà ⇒ người chơi không thấy Nhà MÌNH đang thủng bao nhiêu máu.
 *
 * ⚠️ VÀ VÌ SAO KHÔNG PHẢI "ĐẶT MỘT LẦN RỒI THÔI": camera kẹp biên (bẫy #2) nên khi người chơi
 * tiến sát Nhà địch ở cuối map, điểm cuối của dải cuộn không đủ chỗ để giữ Nhà mình ở tỉ lệ này
 * nữa — camera buộc phải chạy theo, và Nhà mình trôi dần sang trái rồi ra khỏi màn hình. Đó là
 * hành vi ĐÚNG của game có biên; điều khoá được bằng test là "khi đang ở nửa sân mình thì Nhà
 * mình đứng đúng mép trái", chứ không phải "ở mọi toạ độ".
 */
export const PLAYER_SCREEN_ANCHOR = 0.22;

/** Bề ngang vùng nhìn trong TOẠ ĐỘ THẾ GIỚI (px). Scroll được tính bằng đơn vị này. */
/**
 * Bề ngang vùng nhìn trong TOẠ ĐỘ THẾ GIỚI = `viewW / zoom`.
 *
 * ⚠️⚠️ `viewW / zoom`, KHÔNG PHẢI `viewW` — ĐƠN VỊ LÀ THỨ DỄ SAI NHẤT CỦA FILE NÀY.
 * Ở zoom 0,7 thì 1000px màn hình phủ tới `1000 / 0,7 = 1428,57` đơn vị world, nên dùng `viewW` (1000)
 * làm bề ngang vùng nhìn là thiếu 428 đơn vị ⇒ điểm neo đặt sai chỗ.
 *
 * Vì sao đây là hệ quả ĐÚNG và mong muốn của zoom < 1: camera thấy được NHIỀU world hơn bề ngang màn
 * hình, nên nó cuộn được nhiều hơn — chính là điều kiện để cuộn ngang qua sân 2400px.
 */
function worldViewW(g: ArenaCamGeometry): number {
  return viewWidthFor(g.worldW, g.viewW) / zoomOf(g);
}

/**
 * `scrollX` cần để đưa `focusX` (toạ độ world) tới đúng `PLAYER_SCREEN_ANCHOR` của màn hình.
 *
 * ⚠️⚠️ BẪY ZOOM — CHỖ NÀY TỪNG SAI VÀ TEST BẮT ĐƯỢC NGAY, GHI LẠI NGUYÊN VĂN.
 * `Phaser.Camera.scrollX` là toạ độ world ở **GÓC TRÊN-TRÁI** của vùng nhìn, nên nó LUÔN cùng đơn
 * vị với thế giới — KHÔNG nhân/ chia zoom. (Hệ quả: khi `zoom = 0,7` thì vùng nhìn thấy được rộng
 * `viewW / zoom` đơn vị world, tức 1000/0,7 = 1428 > 1000 ⇒ camera cuộn ĐƯỢC nhiều hơn cỡ màn
 * hình, đúng như mong muốn.)
 * Bản nháp đầu của tôi lẫn giữa "px màn hình" và "đơn vị world", nhân `anchorScreen / zoom` vào
 * `scrollX` ⇒ ở zoom 0,7 camera lệch 314px và bài test "Nhà người chơi nằm ở mép trái" ĐỎ.
 * Cách đúng — dùng TỈ LỆ trên bề ngang vùng nhìn:
 *   `offset = worldViewW × PLAYER_SCREEN_ANCHOR` (đơn vị world) ⇒ `scrollX = focusX − offset`.
 */
export function scrollXForFocus(g: ArenaCamGeometry, focusX: number): number {
  const raw = focusX - worldViewW(g) * PLAYER_SCREEN_ANCHOR;
  return clampScroll(raw, maxScrollX(g.worldW, g.viewW));
}

/**
 * `scrollX` khi xem PHE KIA (dùng cho PVP sau này): đối xứng gương của `scrollXForFocus` —
 * "người chơi" (phe phải) nằm ở mép PHẢI, tức cùng tỉ lệ `PLAYER_SCREEN_ANCHOR` tính từ mép kia.
 */
export function scrollXForFocusMirrored(g: ArenaCamGeometry, focusX: number): number {
  const offset = worldViewW(g) * (1 - PLAYER_SCREEN_ANCHOR);
  return clampScroll(focusX - offset, maxScrollX(g.worldW, g.viewW));
}

/**
 * Chiều cao vùng nhìn trong TOẠ ĐỘ THẾ GIỚI = `viewH / zoom`.
 *
 * ⚠️⚠️ BUG ĐÃ SỬA Ở ĐÂY — BẪY GIỐNG HỆT `scrollXForFocus`, VÀ TEST BẮT ĐƯỢC.
 * Bản đầu hàm này trả `viewHeightFor(worldH, viewH)` = **700** — đó là px MÀN HÌNH, không phải đơn vị
 * world. Hệ quả đo được: `scrollYForFocus(500)` cho `500 − 350 = 150`, mà giá trị ĐÚNG phải là
 * `500 − 500 = 0` (vì ở zoom 0,7 vùng nhìn thấy được cao `700 / 0,7 = 1000` đơn vị world, tức đúng
 * bằng chiều cao thế giới ⇒ canh giữa thì `scrollY = 0`).
 * Với `scrollY = 150`, land TRÊN (`top = 96`) nằm ở `(96 − 150) × 0,7 = −37,8px` ⇒ **mất 37,8px đầu
 * của land top khỏi màn hình** — đúng lỗi "người chơi không thấy hết land của mình", chỉ lộ ra khi
 * đo px thật.
 *
 * ⚠️ VÌ SAO `worldViewW` ĐÚNG MÀ `worldViewH` SAI: `worldViewW` được viết sau khi tôi đã dính bẫy
 * đơn vị ở `scrollXForFocus` và ghi chú lại; còn hàm này tôi viết theo phản xạ "vùng nhìn cao bao
 * nhiêu" ⇒ lấy thẳng `viewH`. **Cùng một khái niệm "vùng nhìn" có HAI đơn vị khác nhau** tuỳ ngữ
 * cảnh (px màn hình để vẽ, đơn vị world để tính `scroll`), nên mỗi hàm phải tự nói rõ nó dùng đơn vị
 * nào — đó là lý do 2 hàm này có tên riêng thay vì một `viewSize()` dùng chung.
 */
function worldViewH(g: ArenaCamGeometry): number {
  return viewHeightFor(g.worldH, g.viewH) / zoomOf(g);
}

/** `scrollY` để `focusY` nằm GIỮA màn hình (trận cuộn ngang nên y chỉ cần canh giữa). */
export function scrollYForFocus(g: ArenaCamGeometry, focusY: number): number {
  return clampScroll(focusY - worldViewH(g) / 2, maxScrollY(g.worldH, g.viewH));
}

/**
 * MỘT BƯỚC LÀM MƯỢT (đuổi theo đích) — `dt` giây, `t` = hằng số thời gian (giây).
 *
 * Vì sao cần làm mượt thay vì gán thẳng: 30Hz mô phỏng ⇒ nếu camera gán thẳng vào `focusX` thì khi
 * người chơi bấm summon, Nhà đứng yên mà camera vẫn "giật" theo từng px mỗi tick. Đuổi theo kiểu
 * hàm mũ giữ khung hình êm và vẫn bám sát (sai số < 1px sau ~3 lần `t`).
 *
 * ⚠️ ĐÂY LÀ HÀM THUẦN, KHÔNG PHẢI `Phaser.Math.Linear`: bản của Phaser nhận hệ số nội suy, còn ta
 * cần hệ số bám theo `dt` THẬT của khung hình. Dùng `Lerp` với `0,1` cứng là camera bám NHANH GẤP
 * ĐÔI ở màn 120Hz so với 60Hz — đúng loại lỗi "chạy khác nhau trên máy khác nhau".
 */
export function approach(current: number, target: number, dt: number, t = 0.14): number {
  if (!Number.isFinite(dt) || dt <= 0) return current;
  const k = 1 - Math.exp(-dt / Math.max(0.001, t));
  return current + (target - current) * k;
}

// ════════════════════════════════════════════════════════════════════════════
// 4. BẤT BIẾN "KHÔNG LỘ KHOẢNG TRỐNG NGOÀI MAP" + TIỆN ÍCH CHO TEST
// ════════════════════════════════════════════════════════════════════════════

/**
 * VÙNG NHÌN CÓ NẰM TRỌN TRONG THẾ GIỚI KHÔNG (bẫy #2).
 *
 * Dùng `1e-6` chứ không `===`: mọi phép cộng/ trừ số thực ở trên đều có thể lệch vài ulp, và một
 * bài test đỏ vì `1400.0000000000002 > 1400` là bài test vô nghĩa.
 */
export function viewInsideWorld(g: ArenaCamGeometry): boolean {
  const eps = 1e-6;
  if (g.scrollX < -eps || g.scrollY < -eps) return false;
  if (g.scrollX > maxScrollX(g.worldW, g.viewW) + eps) return false;
  if (g.scrollY > maxScrollY(g.worldH, g.viewH) + eps) return false;
  // vùng nhìn không được rộng/ cao hơn thế giới (vượt ⇒ chắc chắn lộ khoảng trống)
  if (worldViewW(g) > g.worldW + eps || worldViewH(g) > g.worldH + eps) return false;
  return true;
}

/** Dựng một `ArenaCamGeometry` với biên đã kẹp — dùng trong test và trong `ArenaCamera`. */
export function makeCamGeometry(opts: {
  worldW: number;
  worldH: number;
  viewW: number;
  viewH: number;
  view?: CamSide;
  scrollX?: number;
  scrollY?: number;
}): ArenaCamGeometry {
  const g: ArenaCamGeometry = {
    worldW: opts.worldW,
    worldH: opts.worldH,
    viewW: viewWidthFor(opts.worldW, opts.viewW),
    viewH: viewHeightFor(opts.worldH, opts.viewH),
    view: opts.view ?? 'left',
    scrollX: 0,
    scrollY: 0,
  };
  g.scrollX = clampScroll(opts.scrollX ?? 0, maxScrollX(g.worldW, g.viewW));
  g.scrollY = clampScroll(opts.scrollY ?? 0, maxScrollY(g.worldH, g.viewH));
  return g;
}

/**
 * CỠ VÙNG NHÌN THIẾT KẾ CỦA ARENA — HẰNG SỐ, KHÔNG BAO GIỜ LẤY TỪ `scale.width` (bẫy #1).
 *
 * Vì sao 1000×700: rộng 1000 < thế giới 2400 ⇒ CÓ chỗ để cuộn ngang (điều kiện tồn tại của cả file
 * này), và cao 700 < 1000 ⇒ camera cuộn dọc vừa đủ để 3 land lấp màn hình ở zoom 0,7.
 *
 * ⚠️ VÌ SAO CỐ ĐỊNH CHỨ KHÔNG THEO CỬA SỔ: Phaser ở chế độ FIT tự co giãn ảnh ra khung chứa, nên
 * cỡ vùng nhìn KHÔNG cần bằng cỡ cửa sổ. Đổi nó theo cửa sổ là quay lại đúng cái bẫy
 * "camera 1576×404 trong thế giới 1000×600 ⇒ mọi cú bấm lệch" (xem bẫy #1). Cố định còn cho một
 * lợi ích thật: mọi máy, mọi cỡ cửa sổ đều có CÙNG tầm nhìn ⇒ không ai bị lợi/ thiệt thế.
 */
export const ARENA_CAMERA_VIEW: { readonly w: number; readonly h: number } = { w: 1000, h: 600 };

/**
 * TRẦN DIỆN TÍCH ĐIỂM ẢNH NỀN CỦA CANVAS ARENA (px²) — chặn canvas phình trên màn siêu lớn.
 *
 * ⚠️ VÌ SAO CẦN: từ khi khổ ngang cấp `baseSize = cỡ CSS hiển thị × DPR` (sửa bug *"ảnh không nét"*),
 * màn 4K DPR 2 sẽ đòi canvas **7200×4320 ≈ 31 Mpx** — GPU phải tô 31 triệu điểm ảnh mỗi khung cho một
 * sân vẽ 1000×600, hoàn toàn vô ích vì mắt không phân biệt được ở khoảng cách ngồi.
 *
 * 🔢 6.000.000 px² ≈ 3000×2000: đủ cho desktop 1440×900 DPR 2 (cần 2880×1728 = 4,98 Mpx — vẫn 1:1) và
 * cho điện thoại ngang DPR 3 (1950×1170 = 2,28 Mpx), chỉ kẹp ở màn 4K.
 * Kẹp theo DIỆN TÍCH (không theo bề ngang) để mọi tỉ lệ màn hình đều được lợi như nhau.
 */
export const ARENA_LANDSCAPE_CANVAS_AREA_MAX = 6_000_000;

/**
 * HỆ SỐ PHÓNG ĐỘ PHÂN GIẢI CHO **KHỔ NGANG** = `fit × DPR`, kẹp theo trần diện tích — HÀM THUẦN.
 *
 * ⚠️⚠️ VÌ SAO PHẢI LÀ `fit × DPR` CHỨ KHÔNG CHỈ `DPR` (bug người dùng: *"arena khi chơi màn hình ngang
 * ảnh lại không nét"*): canvas nền phải bằng **cỡ CSS hiển thị × DPR** mới là "1 điểm ảnh nền = 1 điểm
 * ảnh vật lý". Cỡ CSS hiển thị của `Scale.FIT` là `cỡ thiết kế × fit` với `fit = min(cw/1000, ch/600)`,
 * nên `cỡ thiết kế × DPR` là CHƯA ĐỦ: màn 1440×900 DPR 2 có `fit = 1,44` ⇒ hiển thị 1440×864 CSS ⇒ cần
 * 2880×1728 nền, mà "thiết kế × DPR" chỉ cho 2000×1200 ⇒ vẫn phóng 1,44× (nhoè).
 * Bản đầu của tôi chỉ dùng `DPR` và bị chính tool đo bắt: desktop vẫn ❌ 1,44×.
 *
 * 🔢 BẢNG ĐO ĐƯỢC (Chrome) — `canvas nền = cỡ thiết kế × hệ số` phải bằng ĐÚNG `physical`:
 * | khổ | fit | DPR | hệ số | canvas nền | CSS | physical |
 * |---|---|---|---|---|---|---|
 * | 844×390 | 0,65 | 2 | **1,30** | 1300×780 | 650×390 | 1300×780 |
 * | 844×390 | 0,65 | 3 | **1,95** | 1950×1170 | 650×390 | 1950×1170 |
 * | 740×360 | 0,60 | 2 | **1,20** | 1200×720 | 600×360 | 1200×720 |
 * | 1440×900 | 1,44 | 2 | **2,88** | 2880×1728 | 1440×864 | 2880×1728 |
 *
 * ⚠️⚠️ VÌ SAO TÍNH ĐƯỢC `fit` MÀ KHÔNG VÒNG LẶP: `displaySize = baseSize × min(cw/baseW, ch/baseH)`;
 * thay `baseSize = thiết kế × s` thì `displaySize = thiết kế × min(cw/thiếtKế, ch/thiếtKế)` — KHÔNG phụ
 * thuộc `s`. Nên `fit` suy từ khung chứa + cỡ thiết kế là chính xác ngay, không cần đo lại sau.
 *
 * ⚠️ KHUNG CHƯA ĐO ĐƯỢC (`cw`/`ch` < 2 px, ví dụ đang ở trang chủ) ⇒ trả về `DPR`: vẫn hơn 1, và
 * `applyArenaLayout` sẽ chạy lại khi khung có kích thước thật.
 * ⚠️ TRẦN 4 VÀ TRẦN DIỆN TÍCH: màn 4K DPR 2 đòi 7200×4320 (31 Mpx) — tốn GPU vô ích; kẹp theo DIỆN
 * TÍCH để mọi tỉ lệ màn hình đều được lợi như nhau.
 */
export function landscapeRenderScaleFor(
  containerW: number,
  containerH: number,
  dpr: number,
  designW: number = ARENA_CAMERA_VIEW.w,
  designH: number = ARENA_CAMERA_VIEW.h,
  areaMax: number = ARENA_LANDSCAPE_CANVAS_AREA_MAX,
): number {
  const d = Number.isFinite(dpr) && dpr > 0 ? dpr : 1;
  if (!(containerW >= 2) || !(containerH >= 2) || !(designW > 0) || !(designH > 0)) return d;
  const fit = Math.min(containerW / designW, containerH / designH);
  const areaCap = Math.sqrt(Math.max(1, areaMax) / (designW * designH));
  return Math.max(0.25, Math.min(4, fit * d, areaCap));
}

// ════════════════════════════════════════════════════════════════════════════
// 4a. KHỔ DỌC — HAI TẦNG: nửa sân ĐỊCH ở TRÊN · nửa sân MÌNH ở DƯỚI
// ════════════════════════════════════════════════════════════════════════════

/**
 * MEDIA QUERY CỦA KHỔ DỌC — MỘT NGUỒN SỰ THẬT CHO CẢ CSS LẪN SCENE.
 *
 * ⚠️ PHẢI GIỐNG HỆT chuỗi trong `src/style.css` (`@media (orientation: portrait) and (max-width: 960px)`).
 * CSS lo bố cục (thanh trên/ dock), scene lo chia 2 tầng; hai bên lệch điều kiện là có khung hình
 * "CSS tưởng dọc, scene tưởng ngang" — sân vẽ sai chỗ mà không có lỗi nào ném ra.
 */
export const ARENA_PORTRAIT_MQ = '(orientation: portrait) and (max-width: 960px)';

/** MỘT TẦNG trong khổ dọc — đủ số để gọi thẳng `camera.setViewport/setZoom/setScroll`. */
export interface ArenaBandView {
  /** `'enemy'` = tầng TRÊN (nửa sân địch, world `x ≥ worldW/2`) · `'own'` = tầng DƯỚI (nửa sân mình). */
  half: 'enemy' | 'own';
  /** Viewport trong hệ canvas (px) — truyền thẳng cho `camera.setViewport`. */
  x: number;
  y: number;
  w: number;
  h: number;
  /** `camera.setZoom`. */
  zoom: number;
  /**
   * `camera.setScroll` — ⚠️ **KHÔNG PHẢI toạ độ mép trái của vùng nhìn**.
   *
   * Phaser zoom quanh TÂM viewport (`Camera.originX/Y = 0,5`): vùng nhìn thật là
   * `[scroll + w/2 − w/(2z), …]` (xem `Camera.preRender`: `midX = scrollX + width/2`,
   * `worldView = mid ± displaySize/2`). Vì vậy để cửa sổ rơi ĐÚNG `[X0, X0 + halfW]` thì
   * `scrollX = X0 + (halfW − contentW)/2`. Công thức này được KHOÁ BẰNG TEST (mô phỏng lại đúng
   * phép tính của Phaser) — sai nó là sân lệch nửa tầng mà mắt thường vẫn thấy "có vẻ ổn".
   */
  scrollX: number;
  scrollY: number;
}

/** Kết quả chia khổ dọc — xem `makeArenaPortraitBands`. */
export interface ArenaPortraitBands {
  /** px canvas trên 1 đơn vị world (bằng `zoom`). */
  scale: number;
  regionTop: number;
  regionBottom: number;
  /** Chiều cao mỗi tầng (px). */
  panelH: number;
  /** Đường chia 2 tầng (px, hệ canvas) — dùng để biết con trỏ đang ở tầng nào. */
  splitY: number;
  /** Chiều cao THẾ GIỚI đang hiện ra mỗi tầng — **bằng `worldH` (600)** vì khổ dọc fit theo CHIỀU CAO. */
  shownWorldH: number;
  /**
   * DẢI TRỐNG hai bên SÂN (px, hệ canvas) — chỗ sân KHÔNG dùng tới.
   *
   * ⚠️ Đây là chỗ để xếp AVATAR (yêu cầu người dùng: *"1 cột dọc 6 avatar bên trái"*, xem
   * `layoutDefaultAvatars`): sân fit chiều cao nên bề ngang chỉ dùng `contentW = halfW × zoom`, phần
   * còn lại là dải trống thật (không phải letterbox của `Scale.FIT` mà là `camera.setViewport` hẹp hơn
   * canvas). Scene phát số này cho HUD qua `arenaPortraitField()` để hai bên dùng CHUNG một hình học.
   *
   * ⚠️ HAI SỐ RIÊNG vì `gutter` (xem dưới) có thể chừa dải TRÁI rộng hơn hẳn dải phải — bản đầu chỉ có
   * một số `stripW` đối xứng, và nó không nói được "dải trái 60px, dải phải 0px".
   */
  stripLeft: number;
  stripRight: number;
  /** Mép TRÊN của dải `y` đang hiện ra (dùng cho test/ chú thích). */
  shownWorldY: number;
  top: ArenaBandView;
  bottom: ArenaBandView;
  /** `false` khi vùng dành cho 2 tầng quá thấp (bàn phím ảo, thanh trên + dock ăn hết) ⇒ đừng vẽ 2 tầng. */
  fits: boolean;
}

/**
 * CHIA KHỔ DỌC THÀNH **HAI TẦNG**: nửa sân địch ở TRÊN, nửa sân mình ở DƯỚI — HÀM THUẦN.
 *
 * Yêu cầu người dùng: *"màn dọc 1/2 sân dọc của player bên dưới, 1/2 sân dọc của enemy bên trên"*.
 *
 * VÌ SAO CẦN (số đo, khổ 412×915): bản đồ 1000×600 nhưng màn chỉ rộng 412 ⇒ ở khổ dọc sân bị **giới
 * hạn bởi BỀ NGANG** nên chỉ cao 247px và để thừa ~510px chiều cao. Cắt đôi theo `x` rồi xếp tầng
 * dùng chính chỗ thừa đó: mỗi tầng chỉ phải chứa 500 đơn vị world bề ngang ⇒ vẽ được ở
 * `min(412/500, 351/600) = 0,585` (so với 0,412) — sân to hơn ~42% mà vẫn thấy CẢ HAI phe.
 *
 * ⚠️ CẮT Ở `worldW/2 = 500` — đúng giữa sông (`ARENA_RIVER.centerX = 499,5`). Hệ quả là **cầu bị cắt
 * đôi**: nửa trái của cầu nằm ở mép PHẢI tầng dưới, nửa phải ở mép TRÁI tầng trên, nên quân qua cầu
 * "nhảy" từ mép này sang mép kia. Đây là ĐÁNH ĐỔI ĐÃ CHỐT của phương án (c1); phương án "cửa sổ chồng
 * lấn" (không cắt cầu) là `splitX` khác — xem `makeArenaPortraitBands` nhận tham số để đổi.
 *
 * ⚠️⚠️ ZOOM = **FIT CHIỀU CAO**, KHÔNG phóng kín bề ngang — YÊU CẦU NGƯỜI DÙNG 02/10/2026:
 * *"Ngoài ra fit độ cao chứ đừng kéo dãn ngang"*.
 *
 * Mỗi tầng phải chứa ĐỦ 600 đơn vị `y` ⇒ `zoom = min((vw − gutter)/halfW, panelH/worldH)`; ở 412×915
 * (thanh trên 98 + dock 60) ra **0,585**, nên bề ngang chỉ dùng `500 × 0,585 ≈ 292px` và mỗi bên thừa
 * một **dải trống ≈ 60px** (`stripLeft`/ `stripRight`). Hai tầng vì thế thấy TRỌN chiều cao sân: 2 mỏ
 * (y = 120/ 480), 2 cầu (105–209 · 377–481), Nhà (y = 300), dải ra quân (240–360) và cả hai mép `y = 0/600`.
 *
 * ⚠️⚠️ `gutter` = DẢI TRỐNG CHỪA SẴN Ở BÊN TRÁI CHO CỘT AVATAR — yêu cầu người dùng: *"1 cột dọc 6 avatar
 * bên trái"*. Cần tham số này vì có những khổ màn mà fit chiều cao cho ra dải trống QUÁ HẸP cho avatar
 * 44px: khi thanh trên/ dock thấp đi (ví dụ bỏ bảng dock), `panelH` tăng ⇒ `zoom` tăng ⇒ sân rộng ra và
 * dải trống co lại. Lúc đó chừa trước `gutter` px ở bên trái: zoom bị chặn bởi `(vw − gutter)/halfW`, sân
 * **dịch sang phải** đúng `gutter`, và cột avatar luôn có chỗ. Đánh đổi: sân nhỏ đi `gutter/vw` (ở 412px
 * với gutter 56 là ~2%) — rẻ hơn nhiều so với việc để avatar đè lên sân.
 *
 * ⚠️ `insetTop`/`insetBottom` là chiều cao THANH TRÊN và DOCK (đo từ DOM) — hàm này KHÔNG tự đo:
 * nó thuần, chạy được trong node, và nhờ vậy `tests/arena-render.test.ts` khoá được hình học.
 */
export function makeArenaPortraitBands(opts: {
  vw: number;
  vh: number;
  insetTop: number;
  insetBottom: number;
  /** px chừa sẵn ở bên TRÁI cho cột avatar (0 = sân canh giữa). Xem khối chú thích trên. */
  gutter?: number;
  worldW?: number;
  worldH?: number;
}): ArenaPortraitBands {
  const worldW = opts.worldW ?? ARENA_RENDER_WORLD.w;
  const worldH = opts.worldH ?? ARENA_RENDER_WORLD.h;
  const halfW = worldW / 2;
  const vw = Math.max(1, opts.vw);
  const vh = Math.max(1, opts.vh);
  const regionTop = Math.min(Math.max(0, opts.insetTop), vh);
  const regionBottom = Math.max(regionTop, vh - Math.max(0, opts.insetBottom));
  const panelH = (regionBottom - regionTop) / 2;
  /* Dải trái chừa trước — kẹp lại để số rác không làm sân biến mất (luôn còn ≥ 55% bề ngang). */
  const gutter = Math.min(Math.max(0, Number.isFinite(opts.gutter) ? (opts.gutter as number) : 0), vw * 0.45);
  const availW = Math.max(1, vw - gutter);

  /* Zoom: vừa bề ngang CÒN LẠI VỪA chiều cao tầng — fit chiều cao là chuẩn nên KHÔNG cắt `y`. */
  const zoomByWidth = availW / halfW;
  const zoom = Math.max(0.05, Math.min(zoomByWidth, panelH / worldH));
  const shownH = Math.min(worldH, panelH / zoom); // = worldH trừ khi màn quá thấp (bàn phím ảo)
  const contentW = halfW * zoom;
  const contentH = shownH * zoom;
  /*
   * SÂN CANH GIỮA TRONG PHẦN BỀ NGANG CÒN LẠI (sau `gutter`) — dải trái vì thế rộng hơn dải phải đúng
   * `gutter` khi zoom bị chặn bởi bề ngang, và bằng nhau khi zoom bị chặn bởi chiều cao.
   *
   * ⚠️ KẸP CUỐI: khi zoom bị chặn bởi CHIỀU CAO, `gutter` không làm zoom nhỏ đi mà chỉ DỊCH sân sang
   * phải ⇒ đẩy quá tay là mép phải sân lọt ra ngoài canvas (`stripRight` âm). Kẹp `x` để mép phải không
   * bao giờ vượt canvas; phần `gutter` "dư" biến thành dải trái rộng hơn — đúng thứ HUD cần.
   */
  const x = Math.min(Math.max(0, gutter + (availW - contentW) / 2), Math.max(0, vw - contentW));
  const topY = regionTop + (panelH - contentH) / 2;
  const bottomY = regionTop + panelH + (panelH - contentH) / 2;
  /* Xem chú thích `ArenaBandView.scrollX` — CÔNG THỨC NÀY LÀ CHỖ DỄ SAI NHẤT. */
  const scrollXAtOwnHalf = (halfW - contentW) / 2;
  /* Canh giữa theo `y` ⇒ cắt ĐỀU trên/ dưới khi `shownH < worldH`. */
  const scrollY = worldH / 2 - contentH / 2;

  const top: ArenaBandView = {
    half: 'enemy',
    x, y: topY, w: contentW, h: contentH,
    zoom,
    scrollX: halfW + scrollXAtOwnHalf,
    scrollY,
  };
  const bottom: ArenaBandView = {
    half: 'own',
    x, y: bottomY, w: contentW, h: contentH,
    zoom,
    scrollX: scrollXAtOwnHalf,
    scrollY,
  };
  return {
    scale: zoom,
    regionTop,
    regionBottom,
    panelH,
    splitY: regionTop + panelH,
    top,
    bottom,
    /* Dải `y` của thế giới ĐANG HIỆN RA — bằng `[0, 600]` (fit chiều cao), hẹp hơn chỉ khi màn quá thấp. */
    shownWorldH: shownH,
    shownWorldY: worldH / 2 - shownH / 2,
    /* Dải trống hai bên sân (dải TRÁI rộng hơn đúng `gutter` khi zoom bị chặn bởi bề ngang). */
    stripLeft: x,
    stripRight: vw - (x + contentW),
    /* Ngưỡng 8px: thấp hơn nữa thì mỗi tầng không còn là "một cái sân" nữa — thà ẩn còn hơn vẽ rác. */
    fits: panelH > 8,
  };
}

/** Con trỏ ở toạ độ canvas `canvasY` đang nằm ở tầng nào (dùng cho `worldFromScreen`). */
export function pickArenaBand(bands: ArenaPortraitBands, canvasY: number): 'top' | 'bottom' {
  return canvasY < bands.splitY ? 'top' : 'bottom';
}

/**
 * MÔ PHỎNG CÔNG THỨC VÙNG NHÌN CỦA PHASER — **CHỈ DÙNG CHO TEST**.
 *
 * Chép lại đúng 3 dòng của `Phaser.Cameras.Scene2D.Camera.preRender`
 * (`midX = scrollX + width/2` · `displayWidth = width/zoomX` · `worldView = mid ± display/2`), để
 * `tests/arena-render.test.ts` khoá được "cửa sổ của mỗi tầng rơi ĐÚNG nửa sân của nó" mà không cần
 * dựng Phaser trong node. Nếu Phaser đổi công thức thì bài test này đỏ ⇒ đó là chủ ý: nó buộc người
 * sửa phải ĐO LẠI trên Chrome thay vì tin vào một công thức đã cũ.
 */
export function phaserWorldViewOf(v: ArenaBandView): { x: number; y: number; w: number; h: number } {
  const midX = v.scrollX + v.w / 2;
  const midY = v.scrollY + v.h / 2;
  const dispW = v.w / v.zoom;
  const dispH = v.h / v.zoom;
  return { x: midX - dispW / 2, y: midY - dispH / 2, w: dispW, h: dispH };
}

// ════════════════════════════════════════════════════════════════════════════
// 4b. ADAPTER `ArenaUnit` → HÌNH DẠNG MÀ `UnitViews` ĐỌC
// ════════════════════════════════════════════════════════════════════════════

/**
 * ADAPTER — CHỖ GIAO NHAU GIỮA SIM ARENA VÀ LỚP VẼ DÙNG CHUNG.
 *
 * ⚠️⚠️ ĐỌC KỸ TRƯỚC KHI "ĐƠN GIẢN HOÁ" — ĐÂY LÀ HỢP ĐỒNG DO `sim-core` VÀ LEAD CHỐT.
 * `UnitViews.sync()` được khai `(dt, world: World)`, mà `World` là kiểu của game TD CŨ. Việc ĐÚNG
 * theo yêu cầu task-3 là **viết adapter trong file CỦA T-C**, KHÔNG sửa `src/render/unitview.ts`
 * (file đó ngoài write scope, và nó là lớp vẽ dùng chung cho cả game hiện tại — sửa nó là đụng vào
 * chế độ đang chạy ổn).
 *
 * Vì sao dùng `as unknown as` thay vì `as` thẳng: TypeScript ĐÚNG khi từ chối ép `ArenaWorld` sang
 * `World` (chúng không có quan hệ cấu trúc — `World` có ~20 trường mà Arena cố ý không có, như
 * `gold`/ `projectiles`/ `hitStop`). Ép qua `unknown` là CÁCH NÓI RÕ "tôi biết mình đang nới kiểu, và
 * tôi đã kiểm bằng test rằng các trường được đọc đều tồn tại".
 *
 * ⚠️ 25 TRƯỜNG `UnitViews` ĐỌC, ĐÃ ĐỐI CHIẾU TỪNG TRƯỜNG và KHÔNG THIẾU TRƯỜNG NÀO (kết luận của T-C
 * sau khi `grep` `unitview.ts`, và được khoá bằng bài test "HỢP ĐỒNG với UnitViews"):
 *   alive · attackMove · base · castAnim · castDur · castT0 · deadAt · facing · hitFlash · hp · id ·
 *   isBoss · isClone · isConverted · isElite · kind · mana · radius · state · swing · team · ultUntil ·
 *   x · y  (+ `base.hp`, `base.mana` cho 2 thanh chỉ số)
 *
 * ⚠️ RỦI RO ĐÃ BIẾT (đã báo Lead, KHÔNG tự xử ở đây): `buildView` tra `enemyName(u.kind)` khi
 * `isBoss`, mà `ARENA_BOSS = 'elise'` KHÔNG có trong `ENEMIES` ⇒ lùi về `stageBossName()`. KHÔNG vỡ
 * (nhánh lùi có sẵn), nhưng nhãn sẽ là tên trùm màn TD — sửa đúng chỗ là `data/enemies.ts` hoặc
 * `i18n/loc.ts`, cả hai đều NGOÀI write scope của T-C.
 */
export class ArenaUnitViewsAdapter {
  private disposed = false;

  constructor(private readonly views: UnitViewsPeer) {}

  /**
   * MỘT KHUNG HÌNH: đẩy toàn bộ unit sống của Arena qua lớp vẽ dùng chung.
   *
   * ⚠️ TRUYỀN `realDt` (giây THẬT của khung hình), KHÔNG phải `DT` của sim. `UnitViews` dùng `dt` cho
   * việc hiển thị (nhịp vung tay, mờ dần của xác) — truyền `DT` cứng thì ở màn 120Hz nhân vật vung
   * tay NHANH GẤP ĐÔI so với 60Hz. Sim vẫn 30Hz cố định, nhưng đó là việc của vòng lặp sim.
   */
  sync(dt: number, world: ArenaWorldLike): void {
    if (this.disposed) return;
    /*
     * ⚠️ KHÔNG CẦN ÉP KIỂU Ở ĐÂY NỮA — và đó là điều đáng nói.
     * Bản đầu tôi khai `sync(dt, world: ArenaWorld)` rồi phải `world as unknown as { units; time }`
     * để nới kiểu sang `World` của game TD cũ. Nay tham số nhận thẳng `ArenaWorldLike` — CẤU TRÚC TỐI
     * THIỂU mà `UnitViews.sync` thật sự đọc (`units` + `time`) — nên không còn phép ép kiểu nào, và
     * TypeScript kiểm được thật: truyền nhầm một object thiếu `.time` là LỖI BIÊN DỊCH.
     * (Đây cũng là hướng Lead đã ghi nhận cho `UnitViews.sync`; khi nào `unitview` đổi chữ ký sang
     * cấu trúc tối thiểu thì adapter này khớp luôn, không phải sửa gì.)
     */
    this.views.sync(dt, world);
  }

  /** Xoá hết sprite khi rời màn. */
  reset(): void {
    this.views.reset();
  }

  /** Scene shutdown ⇒ không đụng vào GameObject đã chết (ảnh nạp muộn/ tween còn chạy). */
  dispose(): void {
    this.disposed = true;
  }
}

// ════════════════════════════════════════════════════════════════════════════
// 5. LỚP MỎNG BỌC PHASER — KHÔNG CHỨA HÌNH HỌC (mọi phép tính ở trên)
// ════════════════════════════════════════════════════════════════════════════

/**
 * Phần `Phaser.Scene` mà camera THẬT SỰ cần.
 *
 * Vì sao khai kiểu tối thiểu thay vì nhận thẳng `Phaser.Scene`: (a) nói rõ camera chỉ đụng đúng 3
 * thứ, người đọc không phải đi tìm; (b) test/ công cụ cân bằng headless có thể dựng một
 * `ArenaCamera` bằng object giả mà không cần cả một Scene thật.
 *
 * ⚠️ KIỂU CAMERA CỦA PHASER 4 LÀ `Phaser.Cameras.Scene2D.Camera`, KHÔNG PHẢI `Phaser.Camera`
 * (`Phaser.Camera` chỉ tồn tại ở Phaser 3). Đã dính lỗi biên dịch TS2724 ngay lần typecheck đầu —
 * ghi lại để người sau không mất thời gian đi tìm.
 */
export interface CameraScene {
  cameras: { main: Phaser.Cameras.Scene2D.Camera };
}

/**
 * CAMERA CUỘN NGANG CHO MÀN 3-LAND.
 *
 * Cách hoạt động (một câu): hình học nằm ở các hàm thuần phía trên; class này giữ
 * `ArenaCamGeometry`, làm mượt `scrollX` mỗi khung hình, rồi **ghi đúng 3 con số** xuống
 * `Phaser.Camera`: `setZoom`, `scrollX`, `scrollY` (qua `centerOn`).
 *
 * ⚠️ KHÔNG BAO GIỜ gọi `setViewport` Ở ĐÂY. Cỡ viewport là việc của scene (nó phải giữ cỡ THIẾT
 * KẾ — xem bẫy #1), còn class này chỉ nhận `viewW/ viewH` để tính hình học.
 *
 * ⚠️⚠️ HAI LOẠI ZOOM — ĐỌC KỸ TRƯỚC KHI THÊM CHỖ DÙNG ZOOM (sửa 02/10/2026, bug *"ảnh không nét ở
 * màn hình ngang"*):
 *   · **zoom THIẾT KẾ** = `zoomOf(geo)` — đơn vị: px THIẾT KẾ trên 1 đơn vị world. Mọi hàm thuần
 *     (`worldToScreenX`, `screenToWorldX`, `scrollXForFocus`, `visibleWidthWorld`…) nói ngôn ngữ này,
 *     và các bài test khoá nó bằng số.
 *   · **zoom GHI XUỐNG PHASER** = `zoomOf(geo) × renderScale` — đơn vị: px NỀN (base px) trên 1 đơn vị
 *     world. `renderScale` = `devicePixelRatio` (khi canvas được cấp độ phân giải nền = CSS × DPR).
 * Chọn giữ hình học ở px THIẾT KẾ (thay vì nhân DPR vào mọi hàm thuần) là CỐ Ý: `zoomFor` có trần
 * `<= 1` và các hàm kẹp biên suy từ nó, nên nhét DPR vào đó là phải viết lại cả tầng hình học (và mọi
 * bài test) chỉ để đổi độ phân giải. Ở đây DPR chỉ đi qua ĐÚNG 2 chỗ: `applyToCamera` (ghi zoom) và
 * `pointerToWorld` (chia trước khi hỏi công thức thuần).
 */
export class ArenaCamera {
  private geo: ArenaCamGeometry;
  private readonly cam: Phaser.Cameras.Scene2D.Camera;
  /** đích đang đuổi tới — tách khỏi `geo.scrollX` để làm mượt (xem `approach`) */
  private targetScrollX: number;
  private disposed = false;
  /**
   * HỆ SỐ PHÓNG ĐỘ PHÂN GIẢI (mặc định 1 = hành vi cũ): canvas có bao nhiêu px NỀN cho mỗi px CSS.
   *
   * ⚠️⚠️ VÌ SAO PHẢI CÓ (BUG NGƯỜI DÙNG: *"arena khi chơi màn hình ngang ảnh lại không nét"*):
   * ở khổ NGANG, scene giữ `baseSize` = cỡ thiết kế 1000×600 — tức canvas chỉ có 1000×600 điểm ảnh
   * trong khi khung hiển thị (điện thoại DPR 2–3) cần tới 1300×780…1950×1170 ⇒ trình duyệt PHÓNG TO
   * bitmap ⇒ nhoè. Khổ DỌC không dính vì nó đã cấp canvas = CSS × DPR.
   * Số đo trước khi sửa (Chrome, 844×390): canvas attr 1000×600 · CSS 650×390 · DPR 2 ⇒ physical
   * 1300×780, **phóng 1,30×** (DPR 3: 1,95×; desktop 1440×900 DPR 2: 2,88×); khổ dọc 412×915 DPR 2
   * thì attr 824×1830 = physical ⇒ **1,00×** (nét).
   */
  private renderScale = 1;

  constructor(scene: CameraScene, worldW: number, worldH: number, viewW = worldW, viewH = worldH) {
    this.geo = makeCamGeometry({ worldW, worldH, viewW, viewH });
    this.cam = scene.cameras.main;
    this.targetScrollX = this.geo.scrollX;
    this.applyToCamera();
  }

  /**
   * ĐẶT HỆ SỐ PHÓNG ĐỘ PHÂN GIẢI — scene gọi khi canvas được cấp `baseSize = cỡ thiết kế × DPR`.
   *
   * ⚠️ KHÔNG tự đọc `devicePixelRatio` trong class này: hình học thuần + camera là hai tầng tách rời
   * (xem khối đầu class), và scene mới là bên quyết định cỡ canvas. Nhận số từ ngoài cũng khiến lớp
   * này test được bằng object giả.
   */
  setRenderScale(scale: number): void {
    const s = Number.isFinite(scale) && scale > 0 ? scale : 1;
    if (s === this.renderScale) return;
    this.renderScale = s;
    this.applyToCamera();
  }

  /** Zoom GHI XUỐNG PHASER (px nền / 1 đơn vị world) = zoom thiết kế × hệ số phóng độ phân giải. */
  private renderZoom(): number {
    return zoomOf(this.geo) * this.renderScale;
  }

  /** Hình học hiện tại — CHỈ ĐỌC (bản sao) để HUD/ test/công cụ đo đọc ra số thật. */
  get geometry(): ArenaCamGeometry {
    return { ...this.geo };
  }

  /** Phe đang được xem. */
  get side(): CamSide {
    return this.geo.view;
  }

  /**
   * ĐỔI CỠ VÙNG NHÌN — GỌI KHI CỬA SỔ ĐỔI KÍCH THƯỚC.
   *
   * ⚠️ PHẢI kẹp lại biên sau khi đổi cỡ: màn hình TO RA thì `maxScrollX` NHỎ ĐI, nên
   * `scrollX` cũ có thể vượt biên ⇒ lộ khoảng trống ngoài map (bẫy #2). Hàm này kẹp lại ngay, và
   * test "phóng to/ thu nhỏ vẫn không lộ khoảng trống" khoá đúng hành vi đó.
   */
  resize(viewW: number, viewH: number): void {
    this.geo.viewW = viewWidthFor(this.geo.worldW, viewW);
    this.geo.viewH = viewHeightFor(this.geo.worldH, viewH);
    this.geo.scrollX = clampScroll(this.geo.scrollX, maxScrollX(this.geo.worldW, this.geo.viewW));
    this.geo.scrollY = clampScroll(this.geo.scrollY, maxScrollY(this.geo.worldH, this.geo.viewH));
    this.targetScrollX = clampScroll(this.targetScrollX, maxScrollX(this.geo.worldW, this.geo.viewW));
    this.applyToCamera();
  }

  /**
   * ĐẶT NGƯỜI CHƠI Ở MÉP TRÁI MÀN HÌNH (yêu cầu người dùng cho PVE).
   *
   * @param side   phe đang xem — `'right'` là đường PVP tương lai (gương lại, xem `setSide`)
   * @param focusX toạ độ world cần neo (thường là `x` Nhà của phe đang xem)
   * @param dt     giây của khung hình này; `0` = đặt thẳng không làm mượt (dùng lúc mở trận)
   */
  followSide(side: CamSide, focusX: number, dt: number): void {
    this.geo.view = side;
    const want = side === 'left' ? scrollXForFocus(this.geo, focusX) : scrollXForFocusMirrored(this.geo, focusX);
    if (dt <= 0) {
      this.geo.scrollX = want;
      this.targetScrollX = want;
    } else {
      this.targetScrollX = want;
      this.geo.scrollX = clampScroll(approach(this.geo.scrollX, want, dt), maxScrollX(this.geo.worldW, this.geo.viewW));
    }
    this.applyToCamera();
  }

  /**
   * ĐỔI SANG XEM PHE KIA (dùng cho PVP sau này) — KHÔNG kèm `focusX` vì lúc đổi phe thì vị trí neo
   * do bên gọi quyết định ở lần `followSide` kế tiếp; ở đây chỉ ghi nhớ phe đang xem.
   */
  setSide(side: CamSide): void {
    this.geo.view = side;
  }

  /** Canh giữa theo chiều DỌC (trận cuộn ngang nên y gần như luôn là giữa thế giới). */
  centerY(focusY: number): void {
    this.geo.scrollY = scrollYForFocus(this.geo, focusY);
    this.applyToCamera();
  }

  /** Toạ độ world của con trỏ màn hình — đi qua ĐÚNG công thức `screenToWorldX/Y` đã test. */
  pointerToWorld(screenX: number, screenY: number): { x: number; y: number } {
    /*
     * ⚠️⚠️ `screenX/Y` Ở ĐƠN VỊ NỀN (đúng thứ `scale.transformX/Y` trả về), còn `screenToWorldX/Y` nói
     * ngôn ngữ px THIẾT KẾ ⇒ phải chia `renderScale` TRƯỚC khi hỏi công thức thuần. Thiếu phép chia
     * này thì ở khổ ngang DPR 2 con trỏ bị coi là xa gấp đôi ⇒ mọi cú bấm lệch gấp đôi.
     */
    return {
      x: screenToWorldX(this.geo, screenX / this.renderScale),
      y: screenToWorldY(this.geo, screenY / this.renderScale),
    };
  }

  /**
   * GHI XUỐNG PHASER.
   *
   * ⚠️ Dùng `centerOn` chứ không phải `scrollX = ...`: Phaser coi `scrollX` là góc trên-trái của
   * vùng nhìn **trong toạ độ world**, và nó tự chia cho `zoom` khi vẽ. Ghi thẳng `scrollX` cũng
   * tương đương về mặt số học, nhưng `centerOn` là API Phaser khuyến nghị và tự làm tròn nhất quán
   * giữa các bản ⇒ ít rủi ro lệch nửa px khi nâng cấp Phaser.
   *
   * ⚠️ Scene có thể đã shutdown (ảnh nạp muộn, tween còn chạy) ⇒ `dispose()` đặt cờ và mọi lần ghi
   * sau đó bị bỏ qua. Đụng vào GameObject của scene đã chết là nguồn lỗi khó tái hiện trong repo này.
   */
  private applyToCamera(): void {
    if (this.disposed) return;
    /*
     * ⚠️ GHI `renderZoom()` (zoom thiết kế × hệ số phóng độ phân giải), KHÔNG phải `zoomOf(geo)`:
     * scene đã cấp `baseSize = cỡ thiết kế × DPR` và `viewport = cỡ thiết kế × DPR`, nên vùng world
     * nhìn thấy = `viewport / zoom = (viewW × DPR) / (zoom × DPR) = viewW / zoom` — ĐÚNG bằng trước
     * khi nhân DPR, tức bố cục không đổi một px, chỉ có bitmap dày lên DPR lần (hết nhoè).
     */
    const zoom = this.renderZoom();
    const vw = viewWidthFor(this.geo.worldW, this.geo.viewW);
    const vh = viewHeightFor(this.geo.worldH, this.geo.viewH);
    // `centerOn` nhận TÂM vùng nhìn (đơn vị world) ⇒ suy từ góc trên-trái đang lưu
    this.cam.setZoom(zoom);
    this.cam.centerOn(this.geo.scrollX + vw / 2, this.geo.scrollY + vh / 2);
  }

  /** Scene shutdown ⇒ ngừng ghi xuống camera đã chết. */
  dispose(): void {
    this.disposed = true;
  }
}
